"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSizeToBytes = exports.Bytes = void 0;
const cafe_utility_1 = require("cafe-utility");
const debug_1 = __importDefault(require("debug"));
const debug = (0, debug_1.default)('bee-js:bytes');
const DECODER = new TextDecoder();
const ENCODER = new TextEncoder();
class Bytes {
    constructor(bytes, byteLength) {
        if (!bytes) {
            throw Error(`Bytes#constructor: constructor parameter is falsy: ${bytes}`);
        }
        if (bytes instanceof Bytes) {
            this.bytes = bytes.bytes;
        }
        else if (typeof bytes === 'string') {
            this.bytes = cafe_utility_1.Binary.hexToUint8Array(cafe_utility_1.Types.asHexString(bytes, { name: 'Bytes#constructor(bytes)' }));
        }
        else if (bytes instanceof ArrayBuffer) {
            this.bytes = new Uint8Array(bytes);
        }
        else if (bytes instanceof Uint8Array) {
            this.bytes = bytes;
        }
        else {
            const unknownInput = bytes;
            const toHex = cafe_utility_1.Objects.getDeep(unknownInput, 'toHex');
            if (cafe_utility_1.Types.isFunction(toHex)) {
                const hex = toHex.call(unknownInput);
                this.bytes = cafe_utility_1.Binary.hexToUint8Array(cafe_utility_1.Types.asHexString(hex, { name: 'Bytes#constructor(bytes)' }));
            }
            else {
                debug('bytes', bytes);
                throw new Error(`Bytes#constructor: unsupported type: ${typeof bytes}`);
            }
        }
        this.length = this.bytes.length;
        if (byteLength) {
            if (Array.isArray(byteLength)) {
                if (!byteLength.includes(this.length)) {
                    throw new Error(`Bytes#checkByteLength: bytes length is ${this.length} but expected ${byteLength.join(' or ')}`);
                }
            }
            else if (this.length !== byteLength) {
                throw new Error(`Bytes#checkByteLength: bytes length is ${this.length} but expected ${byteLength}`);
            }
        }
    }
    static keccak256(bytes) {
        return new Bytes(cafe_utility_1.Binary.keccak256(new Bytes(bytes).toUint8Array()));
    }
    static fromUtf8(utf8) {
        return new Bytes(ENCODER.encode(utf8));
    }
    static fromSlice(bytes, start, length) {
        if (length === undefined) {
            return new Bytes(bytes.slice(start));
        }
        return new Bytes(bytes.slice(start, start + length));
    }
    offset(index) {
        return new Uint8Array(this.bytes.slice(index));
    }
    toUint8Array() {
        return new Uint8Array(this.bytes);
    }
    toHex() {
        return cafe_utility_1.Binary.uint8ArrayToHex(this.bytes);
    }
    toBase64() {
        return cafe_utility_1.Binary.uint8ArrayToBase64(this.bytes);
    }
    toBase32() {
        return cafe_utility_1.Binary.uint8ArrayToBase32(this.bytes);
    }
    toString() {
        return this.toHex();
    }
    toUtf8() {
        return DECODER.decode(this.bytes);
    }
    toJSON() {
        return JSON.parse(this.toUtf8());
    }
    equals(other) {
        return this.toHex() === new Bytes(other).toHex();
    }
    represent() {
        return this.toHex();
    }
}
exports.Bytes = Bytes;
function parseSizeToBytes(sizeStr) {
    const units = {
        B: 1,
        kB: 1000,
        MB: 1000 ** 2,
        GB: 1000 ** 3,
        TB: 1000 ** 4,
        PB: 1000 ** 5,
    };
    const match = sizeStr.match(/^([\d.]+)\s*(B|kB|MB|GB|TB|PB)$/);
    if (!match) {
        throw new Error(`Invalid size format: ${sizeStr}`);
    }
    const value = parseFloat(match[1]);
    const unit = match[2];
    return Math.ceil(value * units[unit]);
}
exports.parseSizeToBytes = parseSizeToBytes;
